import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoginServicesService } from '../shared/services/login-services.service';
// import * as $ from 'jquery';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AppService } from '../shared/services/app.service';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {

  /// icons
  faSpinner = faSpinner;
  user = { name: '', password: '', platform: 'dosmartqa' };
  loader = false;
  language = 'en';
  languages = [
    { short: 'en', fullform: 'English' },
    // { short: 'jp', fullform: 'Japanese' },
  ];
  password = { newPassword: '', confirmPassword: '' };
  register = {
    firstname: '',
    lastname: '',
    emailId: '',
    organization: '',
    password: '',
    confirmPassword: '',
    verified: '',
    groupToken: '',
    // "profile": '',
  };
  toastMsg = '';
  toastMsgResendVerify = '';
  resendEmailID = '';
  slideTimeOut: any;
  resetPassword: any;
  userID: any;
  errors = [];
  usrVerified = 0;
  isOrgDisabled = false;
  isGroupDisabled = false;
  groupToken: any;
  verifyUsrID: any;
  confirmMsgShow = false;
  disLoginBtn = false;
  disRegisterBtn = false;
  publicToken: any;
  constructor(
    public translate: TranslateService,
    private router: Router,
    private loginService: LoginServicesService,
    private cookieService: CookieService,
    private appService: AppService
  ) {
    // translate.addLangs(["en", "jp"]);
    translate.setDefaultLang('en');
    this.cookieService.delete('language');
    this.cookieService.set('language', this.language);
    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|jp/) ? browserLang : 'en');
  }

  ngOnInit(): void {
    // this.user = { "name": '', "password": '', "platform":'dosmartqa' };
  }
  login(user: any) {
    $('.loginspinner').show();
    this.disLoginBtn = true;
    this.loader = true;

    this.loginService.userLogin(user).subscribe((response: any) => {
      console.log('login res', response);
      if (response.statusCode == 200) {
        // console.log('response login success', response);
        this.publicToken = response.token;
        this.triggerToast(this.appService.getResourceText('B005'));
        localStorage.setItem('publicToken', response.token);
        localStorage.setItem(
          'userName',
          response.user_display_name.toUpperCase()
        );
        localStorage.setItem('userID', response.userId);
        localStorage.setItem('loginDetails', JSON.stringify(response));
        localStorage.setItem('membership', response.membership);
        this.cookieService.set(
          'UserName',
          response.user_display_name.toUpperCase()
        );
        this.cookieService.set('activeusername', response.username);
        $('.loginspinner').hide();
        this.loader = false;
        this.router.navigateByUrl('/main');
      } else if (response.statusCode == 401) {
        this.disLoginBtn = false;
        this.triggerToast(this.appService.getResourceText("B006"));
        $('.loginspinner').hide();
        this.loader = false;
      }
      else if (response.statusCode == 403) {
        this.disLoginBtn = false;
        this.triggerToast("Your account has been expired");
        $('.loginspinner').hide();
        this.loader = false;
      }
      else if (response.statusCode == 402) {
        this.disLoginBtn = false;
        this.triggerToast(this.appService.getResourceText("B030"));
        $('.loginspinner').hide();
        this.loader = false;
      }
      else if (response.statusCode == 500) {
        this.disLoginBtn = false;
        this.triggerToast(this.appService.getResourceText("B029"));
        $('.loginspinner').hide();
        this.loader = false;
      } else {
        this.disLoginBtn = false;
        this.triggerToast(this.appService.getResourceText("B002"));
        $('.loginspinner').hide();
        this.loader = false;
      }
    });
  }

  loginFormSubmit(user: any) {
    localStorage.clear();
    if (
      (user.name == '' && user.password == '') ||
      (user.name == undefined && user.password == undefined)
    ) {
      this.triggerToast(this.appService.getResourceText('V001'));
    } else if (user.name == '' || user.name == undefined) {
      if (user.password == '' || user.password == undefined) {
        this.triggerToast(this.appService.getResourceText('V001'));
      } else {
        this.triggerToast(this.appService.getResourceText('V018'));
      }
    } else if (user.password == '' || user.password == undefined) {
      if (user.name == '' || user.name == undefined) {
        this.triggerToast(this.appService.getResourceText('V001'));
      } else {
        this.triggerToast(this.appService.getResourceText('V002'));
      }
    } else if (user.name && user.password) {
      this.login(user);
    } else {
      this.triggerToast(this.appService.getResourceText('R004'));
    }
  }
  triggerToast(message: string) {
    this.toastMsg = message;
    // $('#snackbar').html(message);
    // var x: any = document.getElementById('snackbar');
    // x.className = 'show';
    setTimeout(() => {
      this.toastMsg = '';
    }, 3000);
  }

  triggerToastResendVerify(message: string) {
    this.toastMsgResendVerify = message;
    $('#resendVerifyErrMsg').html(message);
    var x: any = document.getElementById('resendVerifyErrMsg');
    x.className = 'show';
    setTimeout(function () {
      x.className = x.className.replace('show', '');
    }, 3000);
  }

  goToResetPassword(username: any) {
    // console.log('username', username);
    this.router.navigateByUrl('/forgotpassword');
  }

  backToLogin() {
    this.router.navigateByUrl('/login');
  }

  registerUser() {
    this.router.navigateByUrl('/register');
  }

  updateLanguage(lang: any) {
    this.cookieService.delete('language');
    this.cookieService.set('language', lang);
  }
}
